import { getHistoryUrlParams } from '@/store/gamestate/gamestate'

const practiceCalls = {
  // api_account_practice_stats({ commit, dispatch, getters }) {
  //   dispatch('api_call', {
  //     endpoint: 'account/practice-stats/',
  //     mutation: 'api_account_practice_stats',
  //   })
  // },
  api_practice_builder({ commit, rootState, dispatch, getters }) {
    let { history_spots, history_spot, query_board_filter, street, gameformat } = getters
    history_spots = history_spots.filter(e => e.id < history_spot?.id)
    const hp = getHistoryUrlParams({ history_spots })
    const board = getters
      .street_board(street)
      .filter(c => !c.includes('E'))
      .join('')

    const boardFilterParams = {}
    Object.keys(query_board_filter).forEach(key => {
      if (query_board_filter[key]) {
        const opts = query_board_filter[key].split(',').filter(i => i)
        boardFilterParams[key] = key === 'flop_subset' ? Number(opts[0]) : opts
      }
    })

    const params = {
      gametype: gameformat.gametype,
      depth: gameformat.depth,
      stacks: gameformat.stacks,
      preflop_actions: hp.preflop_actions,
      flop_actions: hp.flop_actions,
      turn_actions: hp.turn_actions,
      river_actions: hp.river_actions,
      board,
      ...boardFilterParams,
    }
    const res = dispatch('api_call', {
      mutation: 'api_practice_setup',
      method: 'POST',
      endpoint: 'poker/practice/practice-hands/',
      action: 'gamestate_set_api_practice_builder',
      data: params,
    })
    return res
  },
}

export default practiceCalls
